import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#5DCB42",
    },
    secondary: {
      main: "#5DCB42",
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
